import { render } from "./AllOrders.vue?vue&type=template&id=691c3ac6"
import script from "./AllOrders.vue?vue&type=script&lang=js"
export * from "./AllOrders.vue?vue&type=script&lang=js"

import exportComponent from "/Users/susana/Local Sites/rhinodoors_dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__